<template>
  <a-card :bordered="false" :headStyle="{ fontSize: '18px' }">
    <template slot="title">
      <div class="title-box">
        <span class="title">大学生认证<span>*基于微信小程序大学生认证数据，启用仅小程序可完成认证</span></span>
        <a-popconfirm @confirm="updateSwitchEvent" placement="leftBottom">
          <template slot="title">
            <p class="p-tips">请点击微信学生身份快速验证相关说明，按流程开启对应组件能力后方可生效。
              https://developers.weixin.qq.com/miniprogram/dev/platform-capabilities/industry/student.html？</p>
          </template>
          <a-switch
            :loading="switchLoading"
            :default-checked="false"
            :checked="enable"
            checked-children="开"
            un-checked-children="关"/>
        </a-popconfirm>
      </div>
    </template>
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['name','phone']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="20"
      requestType="post"
      :requestPromise="loadDataList"
    >
      <a-form-item slot="name" label="姓名" v-bind="searchItemLayout">
        <a-input v-model="queryParams.name" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <a-form-item slot="phone" label="手机号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.phone" placeholder="请输入" allowClear></a-input>
      </a-form-item>
      <template slot="certStatus" slot-scope="rowItem">
        {{ rowItem.record.certStatus ? '有效' : '无效' }}
      </template>
      <template slot="idType" slot-scope="rowItem">
        {{ getTypeName(cardTypeList, rowItem.record.idType) }}
      </template>
    </search-page-view>
  </a-card>
</template>
<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'VerificationList',
  mixins: [searchForm],
  components: {},
  data() {
    return {
      switchLoading: false,
      enable: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      showDialog: false,
      cardTypeList: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '90px'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          width: '120px'
        },
        {
          title: '手机号',
          dataIndex: 'phone',
          width: '120px'
        },
        {
          title: '证件类型',
          dataIndex: 'idType',
          width: '100px',
          scopedSlots: { customRender: 'idType' }
        },
        {
          title: '证件号码',
          dataIndex: 'idNo',
          width: '180px'
        },
        {
          title: '认证状态',
          dataIndex: 'certStatus',
          width: '100px',
          scopedSlots: { customRender: 'certStatus' }
        },
        {
          title: '认证时间',
          dataIndex: 'certTime',
          width: '160px'
        },
        {
          title: '认证过期时间',
          dataIndex: 'certExpireTime',
          width: '160px'
        }
      ],
      queryParams: {}
    }
  },
  created() {
    this.getCardTypeList()
  },
  activated() {
    this.getEnableStatus()
    this.$refs.pageList?.refresh(false)
  },
  methods: {
    loadDataList(params) {
      const data = {
        ...params,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }
      return this.getHttpServices().getMemberAuthService().post('/authStudent/page', data)
    },
    getTypeName(list, code) {
      if (code && list && list.length) {
        let findItem = list.find(item => item.code == code)
        if (findItem) {
          return findItem.name
        }
        return ''
      }
    },
    getCardTypeList() {
      const url = '/base/sysCode/getCardType'
      this.getHttpServices().getBaseService().get(url)
        .then(list => {
          this.cardTypeList = list
          console.error('--cardTypeList----', list)
        })
        .catch(err => {
          console.log(err)
        })

    },
    getEnableStatus() {
      const url = '/authStudent/pc/getEnableStatus'
      const userInfo = this.$store.getters.userInfo
      let merchantId = userInfo.merchantId
      const params = {
        merchantId: merchantId
      }
      this.getHttpServices().getMemberAuthService().get(url, params)
        .then(res => {
          this.enable = !!res
        })
        .catch(err => {
          if (err && err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('获取状态，请重试！')
          }
        })

    },
    updateSwitchEvent() {
      this.switchLoading = true
      this.getHttpServices().getMemberAuthService().post('/authStudent/enableAuth')
        .then(res => {
          this.switchLoading = false
          this.enable = !!res
          this.$refs.pageList.refresh(false)
        })
        .catch(err => {
          this.switchLoading = false
          if (err && err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
        })
      console.error('updateSwitchEvent')
    }
  }
}
</script>
<style scoped lang="less">
.title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    font-size: 20px;
    font-weight: 500;

    span {
      font-size: 14px;
      font-weight: 400;
    }
  }
}

.p-tips {
  max-width: 400px;
  overflow-wrap: break-word;
  word-break: break-all;
}
</style>